import React from 'react';
import { CaretDownOutlined, LoadingOutlined } from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';
import classNames from 'classnames';
import DashboardLink from '../DashboardLink';
import styles from './index.less';
import { track } from '@utils';
import { CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN } from '@src/utils/sensor/track';

const onDropdownItemClick = () => {
  track({
    event: CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN,
  });
};

const renderDropdownGroupItems = (dropdownList = [], groupName) => (
  <Menu.ItemGroup key={groupName} title={groupName}>
    {dropdownList.map((item) => (
      <Menu.Item key={item.id.toString()}>
        <DashboardLink
          dashboard={item}
          className={classNames({
            [styles.unsaved]: !item.isSaved,
          })}
        />
      </Menu.Item>
    ))}
  </Menu.ItemGroup>
);

const DashboardDropdown = ({ id, className, title, isFetching, list }) => {
  const items = list.filter((item) => item.isSaved);

  const menu = (
    <Menu className={styles.menu} selectedKeys={[id.toString()]} onClick={onDropdownItemClick}>
      {renderDropdownGroupItems(items, 'Saved Dashboards')}
    </Menu>
  );

  if (list.length > 0) {
    return (
      <Dropdown overlay={menu} id={id} trigger={['click']}>
        <span id="tabs-show" className={classNames(className)}>
          {isFetching ? (
            <LoadingOutlined />
          ) : (
            <>
              {title}
              <CaretDownOutlined />
            </>
          )}
        </span>
      </Dropdown>
    );
  }
  return null;
};

DashboardDropdown.defaultProps = {
  id: null,
  className: '',
  title: '',
};

export default DashboardDropdown;
